import { motion } from "framer-motion";
import { WHY_POINTS } from "@/data/content";

export default function WhyUusimaa() {
  return (
    <section id="varfor" data-testid="why-section" className="border-b border-white/10 bg-coal py-20 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="mb-14 sm:mb-16"
        >
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-neutral-500">05 / Varför Uusimaa</p>
          <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none tracking-tight text-white sm:text-5xl">
            Fyra skäl att <span className="text-neutral-500">välja oss</span>
          </h2>
        </motion.div>

        <div className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2">
          {WHY_POINTS.map((point, i) => (
            <motion.div
              key={point.num}
              data-testid={`why-point-${point.num}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.1, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="steel-card group bg-void p-7 transition-colors duration-300 sm:p-10"
            >
              <div className="flex items-center gap-4">
                <span className="font-mono text-xs tracking-[0.2em] text-weld">{point.num}</span>
                <span className="h-px flex-1 bg-white/10 transition-colors duration-300 group-hover:bg-white/25" />
              </div>
              <h3 className="mt-6 font-display text-2xl font-bold uppercase tracking-tight text-white sm:text-3xl">
                {point.title}
              </h3>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-neutral-400 sm:text-base">{point.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
